import React, { memo } from 'react';
import { Typography } from '@mui/material';
import Main from '../Main/Main';

const Error = props => (
  <Main title="Ocorreu um erro" className="tela-dashboard">
    <Typography variant="subtitle1">
      Ocorreu um erro.
      {props && props.erro ? props.erro : ''}
      Ocorreu um erro no servidor, favor entrar em contato com o suporte.
    </Typography>
  </Main>
);
export default memo(Error);
